module.exports = __webpack_public_path__ + "chefy-broker-notes.png?4c6b423ae8b35669a380e12789492e94";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chefy-broker-notes.png
// module id = 42
// module chunks = 0